export const FETCH_SLIPS = 'FETCH_SLIPS'
export const GET_SLIP = 'GET_SLIP'

